import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import CustomDropdown from '../../designSystem/FormikDropdownInput/FormikDropdownInput';
import { SALES_MANAGER_USERS } from '../../graphql/queries/user';

interface User {
  id: string;
  number: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phone: string | null;
  title: string;
  updatedAt: string;
}

interface SalesManagerFieldProps {
  name: string;
  label?: string;
  placeholder?: string;
  onUserChange?: (user: User | null) => void;
}

const SalesManagerField: React.FC<SalesManagerFieldProps> = ({
  name,
  label,
  placeholder = 'Select',
  onUserChange,
}) => {
  const { loading, data } = useQuery(SALES_MANAGER_USERS);

  const options = useMemo(() => {
    if (!data?.salesManagerUsers) return [];
    return data.salesManagerUsers.map((user: User) => ({
      value: user.id,
      label: user.fullName,
      user,
    }));
  }, [data]);

  return (
    <div className="my-5">
      <CustomDropdown
        name={name}
        label={label}
        options={options}
        isLoading={loading}
        placeholder={placeholder}
        onChange={(valueObj) => {
          if (onUserChange) {
            onUserChange(valueObj?.user || null);
          }
        }}
      />
    </div>
  );
};

export default SalesManagerField;
